import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import PhsApplyRq from '@domain/rq/phs/apply/PhsApplyRq';
import PhsTutorialApplyRq from '@domain/rq/phs/apply/PhsTutorialApplyRq';
import { PhsApplyResultsRs } from '@domain/rs/phs/apply/PhsApplyResultsRs';
import PHSApplyRs from '@domain/rs/phs/apply/PhsApplyRs';
import PhsApplyStatusRs from '@domain/rs/phs/apply/PhsApplyStatusRs';

const phsApplyPrefix = '/phs/apply';

export default interface PHSApplyRepo {
  //응시 정보 생성
  fetchPHSApply(rq: PhsApplyRq): Promise<AxiosResponse<PHSApplyRs>>;

  //체험판 응시 정보 생성
  fetchPHSTutorialApply(rq: PhsTutorialApplyRq): Promise<AxiosResponse<PHSApplyRs>>;

  // 응시 이력 조회
  fetchPHSApplyHistories(): Promise<AxiosResponse<PhsApplyResultsRs>>;

  //개종검 가장 최근 응시 상태
  fetchPHSApplyStatus(): Promise<AxiosResponse<PhsApplyStatusRs>>;
}

export class RemotePHSApplyRepo implements PHSApplyRepo {
  fetchPHSApply(rq: PhsApplyRq): Promise<AxiosResponse<PHSApplyRs>> {
    return axios.post(`/v2${phsApplyPrefix}`, {
      ...rq,
    });
  }

  fetchPHSTutorialApply(rq: PhsTutorialApplyRq): Promise<AxiosResponse<PHSApplyRs>> {
    return axios.post(`/v2${phsApplyPrefix}/practice`, {
      ...rq,
    });
  }

  fetchPHSApplyHistories(): Promise<AxiosResponse<PhsApplyResultsRs>> {
    return axios.get(`${phsApplyPrefix}/histories`);
  }

  fetchPHSApplyStatus(): Promise<AxiosResponse<PhsApplyStatusRs>> {
    return axios.get(`${phsApplyPrefix}/status`);
  }
}
